<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-employee" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" v-bind:class="size" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera
                </div>

                <div class="modal-body pb-0">
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" label="Anställningsnr." :rules="[rules.required]" v-model="employeeNumber" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" label="Förnamn" v-model="firstName" :rules="[rules.required]" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" label="Efternamn" v-model="lastName" :rules="[rules.required]" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" type="date" label="Anställningadatum" v-model="employmentDate" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" type="date" label="Yrkets startdatum" v-model="occupationStartDate" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-text-field bg-color="white" label="Personnummer" :rules="[rules.socialsecurityformat]" v-model="socialSecurityNumber" variant="outlined"></v-text-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" id="aad" name="aad" :items="internalModel.JobPositions" v-model="selectedJobPosition" item-title="Name" item-value="JobPositionId"></v-select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <v-select bg-color="white" variant="outlined" label="Kön" :items="sexes" v-model="sex" item-title="name" item-value="value"></v-select>
                            </div>
                        </div>
                        <div class="row" v-if="analysisCriterias1.length > 1">
                            <div class="col">
                                <v-select bg-color="white" variant="outlined" v-bind:label="analysisCriteria1Name" :items="analysisCriterias1" v-model="analysisCriteria1"></v-select>
                            </div>
                        </div>
                        <div class="row" v-if="analysisCriterias2.length > 1">
                            <div class="col">
                                <v-select bg-color="white" variant="outlined" v-bind:label="analysisCriteria2Name" :items="analysisCriterias2" v-model="analysisCriteria2"></v-select>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import AdminService from "../../../Services/AdminService";
    import WageService from "../../../Services/WageService";
    import ValidationService from "../../../Services/ValidationService";
    import { getCurrentInstance } from 'vue'

    export default {
        emits: ['updated'],
        name: 'update-employee',
        props: {
            model: Object
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async save() {
                await WageService.UpdateEmployee(this.employeeId, this.employeeNumber, this.firstName, this.lastName, this.socialSecurityNumber, this.sex, this.employmentDate, this.occupationStartDate, this.analysisCriteria1, this.analysisCriteria2, this.selectedJobPosition);
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
                this.$emit("updated");  
            },
            async getEmployeeAnalysisCriteria() {
                var analysisCriterias = await AdminService.getAnalysisCriterias();
                if (analysisCriterias.Criteria1.Active == true) {
                    //this.analysisCriteria1 = analysisCriterias.Criteria1.Name;
                    this.analysisCriterias1 = analysisCriterias.Criteria1.ContentStrings;
                    this.analysisCriteria1Name = analysisCriterias.Criteria1.Name;
                }
                
                if (analysisCriterias.Criteria2.Active == true) {
                    //this.analysisCriteria2 = analysisCriterias.Criteria2.Name;
                    this.analysisCriterias2 = analysisCriterias.Criteria2.ContentStrings;
                    this.analysisCriteria2Name = analysisCriterias.Criteria2.Name;
                }
                
            },
            open(item) {
                this.employeeId = item.EmployeeId;
                if (item.EmploymentDate != null && typeof (item.EmploymentDate) != "undefined" && item.EmploymentDate != "") {
                    this.employmentDate = item.EmploymentDate.split('T')[0]
                }
                else
                    this.employmentDate = "";
                if (item.OccupationStartDate != null && typeof (item.OccupationStartDate) != "undefined" && item.OccupationStartDate != "") {
                    this.occupationStartDate = item.OccupationStartDate.split('T')[0]
                }
                else
                    this.occupationStartDate = "";
                this.firstName = item.FirstName;
                this.lastName = item.LastName;
                this.employeeNumber = item.EmployeeNumber;
                if (item.Sex == "undefined")
                    this.sex = "";
                else
                    this.sex = item.Sex;
                this.socialSecurityNumber = item.SocialSecurityNumber;
                this.selectedJobPosition = item.JobPositionId;
                this.analysisCriteria1 = item.AnalysisCriteria1;
                this.analysisCriteria2 = item.AnalysisCriteria2;
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            create() {
                this.reset();
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            reset() {
                this.employeeId = null;
                this.occupationStartDate = null;
                this.employmentDate = null;
                this.firstName = null;
                this.lastName = null;
                this.employeeNumber = null;
                this.socialSecurityNumber = null;
                this.selectedJobPosition = null;
                this.analysisCriteria1 = null;
                this.analysisCriteria2 = null;
                this.sex = "";
            },
        },
        data() {
            return {
                sexes: [{ name: "Odefinierat", value: "" }, { name: "Man", value: "Man" }, { name: "Kvinna", value: "Kvinna" }],
                rules: ValidationService.rules(),
                employeeId:null,
                occupationStartDate:null,
                employmentDate:null,
                firstName: null,
                lastName:null,
                employeeNumber:null,
                socialSecurityNumber:null,
                selectedJobPosition: null,
                dialogueVisible: false,
                name: "",
                sex: "",
                analysisCriteria1: null,
                analysisCriterias1: [],
                analysisCriteria1Name: null,
                analysisCriteria2: null,
                analysisCriterias2: [],
                analysisCriteria2Name: null,
                moduleId: -1,
                thisModal: {},
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                }
            };
        },
        watch: {

        },
        mounted() {
            this.internalModel = this.model;
            this.getEmployeeAnalysisCriteria();
            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});

            //window.emitter.on('display_login', this.close);
        },
        // eslint-disable-next-line
        setup(props, { emit }) {}
    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .modal-content{
        border-radius:unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }
    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius:unset;
    }
</style>
